import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import GlassModal from '../../v2/MUI_custom_component/Modal/GlassModal';
import CustomButton from '../../v2/MUI_custom_component/Button/CustomButton';
import CustomChip from '../Components/CustomChip';
import { toCapitalized } from '../../v2/Utils/Capitalize';

export default function SelectRoleModal({
  visible = false,
  onClose = () => {},
  onFinish = () => {},
  promptDetails = {},
  allInfluencerRoles = [],
}) {
  const [selectedRole, setSelectedRole] = useState(null);

  useEffect(() => {
    setSelectedRole(null);
  }, [visible]);

  return (
    <GlassModal
      open={visible}
      onClose={onClose}
      title="Add New Role"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {allInfluencerRoles.map((role) => {
            const isSelected =
              selectedRole?.firm_role_id === role.firm_role_id;
            return (
              <CustomChip
                key={role.firm_role_id}
                label={toCapitalized(role.display_name)}
                selected={isSelected}
                onClick={() => setSelectedRole(role)}
                onDelete={isSelected ? () => setSelectedRole(null) : undefined}
              />
            );
          })}
        </Box>

        <CustomButton
          variant="filled"
          color="primary"
          label="Continue"
          disabled={!selectedRole}
          onClick={() => onFinish(promptDetails?.id, selectedRole)}
          sx={{ width: '100%' }}
        />
      </Box>
    </GlassModal>
  );
}
